import React, { useState, useEffect, useMemo } from 'react';
import { Stack, TextField, FormControl, Typography, Divider, InputLabel, Paper, Grid, Box,
  Select, MenuItem, Button
} from '@mui/material';
import { useSnackbar } from 'notistack';
// import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
// import FullScreenModal from 'components/FullScreenModal';
// import useConfirm from 'core/hooks/useConfirm';
// import EditIcon from '@mui/icons-material/Edit';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import { getLibraryBookings } from 'services/bookings';

import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { tConvert, getDbFormat,getBookingStatus } from 'utils/common';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadBlob } from 'components/reactdata-grid';

const defaultFilterValue = [
  { name: 'booking', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
      if(filterValue === null){
        return true;
      };
      const { bookingId, fromDate, fromTime, seatIds } = data || {};

      return (
        bookingId?.toLowerCase()?.includes(filterValue.toLowerCase())
        || bookingId?.toLowerCase()?.includes(filterValue.toLowerCase())
        || fromDate?.toLowerCase()?.includes(filterValue.toLowerCase())
        || tConvert(fromTime)?.toLowerCase()?.includes(filterValue.toLowerCase())
        || (seatIds || []).join(', ').toLowerCase()?.includes(filterValue.toLowerCase())
      );
    }
  },
  { name: 'payment', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { transactionId, paymentChannel } = data?.bookingTransaction || {};
    return (transactionId?.toLowerCase()?.includes(filterValue.toLowerCase())
      || paymentChannel.toLowerCase()?.includes(filterValue.toLowerCase())
    );
  }},
  { name: 'lib_deatils', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { address, name } = data?.library || {};
    const addressArr= [];
    addressArr.push(address?.area);
    addressArr.push(address?.city);
    addressArr.push(address?.state);
    addressArr.push(address?.country);
    addressArr.push(address?.pin);
    const addressStr = (addressArr.filter((ele)=> !!ele ).join(', ') || ''); 

    return (addressStr.toLowerCase().includes(filterValue.toLowerCase())
      || name.toLowerCase().includes(filterValue.toLowerCase())
    );
  }},
  { name: 'cust', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { displayName, mobile, email } = data?.user || {};
    return displayName?.toLowerCase()?.includes(filterValue.toLowerCase()) || mobile?.toLowerCase()?.includes(filterValue.toLowerCase()) || email?.toLowerCase()?.includes(filterValue.toLowerCase());
  }},
  // { name: 'amount', operator: 'gte', type: 'number',  fn: ({ value, filterValue, data }) => {
  //   // if(filterValue === null){
  //   //   return true;
  //   // };
  //   const { amount } = data?.bookingTransaction  || {};
  //   console.log('filterValue', filterValue, amount)
  //   return amount > filterValue;
  // } },
];

const BookingsPage = () => {
  const gridStyle = useMemo(() => ({ minHeight: 480, width: '100%' }), []);
  const [ filterDates, setFilterDates] = React.useState([new Date(), new Date()]);
  const [allBookings, setAllBookings] = useState([]);
  const [bookingStatus, setBookingStatus] = useState('All');
  const [gridRef, setGridRef] = useState(null);
  // const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // const confirm = useConfirm();
  // const [libraryInfo, setLibraryInfo] = useState({ id: null });

  const getLabelAndValueFormat = (label, value) => {
    return (
      <Box>
        <Typography variant="subtitle2" component="span">{label}: </Typography>
        <Typography variant="body2" component="span">
        {value}
        </Typography>
      </Box>
    )
  }
  // const onActionBtnClick = useCallback((e, type, libraryId) => {
  //   e.preventDefault();
  //   if(type === 'edit'){
  //     editLibraryDetails(libraryId);
  //   }else if(type === 'delete') {
  //     onDeleteLibrary(libraryId);
  //   }
  // }, []);


  const columns = useMemo(() => ([
    { name: 'booking', header: 'Booking Details', width: 300, render: ({data} ) => {
      return (
      <>
        {data?.bookingId ? getLabelAndValueFormat('Booking No', data?.bookingId): null}
        {data?.fromTime ? getLabelAndValueFormat('Timing', tConvert(data?.fromTime)): null}
        {data?.fromDate ? getLabelAndValueFormat('Date', data?.fromDate): null}
        {data?.seatCount ? getLabelAndValueFormat('Total Seats', data?.seatCount): null}
        {data?.seatIds?.length > 0 ? getLabelAndValueFormat('Seat No', data?.seatIds.join(',')): null}
      </>);
    }},
    { name: 'payment', header: 'Payment', width: 260, render: ({data} ) => {
      return (
        <>
          {data?.bookingTransaction?.paymentChannel ? getLabelAndValueFormat('Type', data?.bookingTransaction?.paymentChannel): null}
          {data?.bookingTransaction?.transactionId ? getLabelAndValueFormat('TxnId', data?.bookingTransaction?.transactionId): null}
        </>
      )
    }},
    { name: 'lib_deatils', header: 'Library Details', width: 250, render: ({data} ) => data?.library?.name || ''},
    { name: 'cust', header: 'Customer Details', width: 200, render: ({data} ) => { 
      return (
        <>
          {data?.user?.userId ? getLabelAndValueFormat('CustId', data?.user?.userId): null}
          {data?.user?.firstName ? getLabelAndValueFormat('Name', data?.user?.firstName): null}
          {data?.user?.mobile ? getLabelAndValueFormat('Mobile', data?.user?.mobile): null}
        </>
      ); 
    }},
    { name: 'amount', header: 'Amount', width: 120, render: ({data}) => data?.bookingTransaction?.amount},
    { name: 'status', header: 'Status', width: 120, render: ({data}) => getBookingStatus(data)},
    { name: 'createdOn', header: 'Created On', width: 120 },
    // { name: 'actions', header: 'Actions', width: 150, render: ({data}) => {
    //   return (
    //     <Stack direction="row" spacing={1}>
    //       <Box>
    //         <Tooltip title="Edit Booking Details" arrow placement="left">
    //           <IconButton onClick={(e) => onActionBtnClick(e, 'edit', data.libraryId)}>
    //             <EditIcon color="warning" />
    //           </IconButton>
    //         </Tooltip>
    //       </Box>
    //       <Box>
    //         <Tooltip title="Delete Library" arrow placement="left">
    //           <IconButton onClick={(e) => onActionBtnClick(e, 'delete', data.libraryId)} >
    //             <DeleteForeverIcon color="error" />
    //           </IconButton>
    //         </Tooltip>
    //       </Box>
    //     </Stack>
    //   )
    // }},
  ]),[]);

  useEffect(() => {
    getBookingsDataByDate();
  }, []);


  function getBookingsDataByDate() {
    const [fromDate,  toDate] = filterDates;
    const date = {fromDate: getDbFormat(fromDate), toDate: getDbFormat(toDate)};
    getLibraryBookings(date).then(({response, error}) => {
      if(response){
        setAllBookings([...(response || [])]);
      } else {
        setAllBookings([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  // const onDeleteLibrary = (libraryId) => {
  //   confirm({ title: 'Delete Library?', description: 'This library will be deleted and this cannot be undone. Are you sure you want to proceed?' })
  //   .then(() => { 
  //     deleteProperty(libraryId);
  //   })
  //   .catch(() => { 
      
  //   });
  // }

  // const deleteProperty = (libraryId) => {
  //   deleteLibrary({libraryId}).then(({response, error}) => {
  //     if(response){
  //       enqueueSnackbar("Library deleted successfully", {variant: 'success?'});
  //       // getApprovalList();
  //     } else {
  //       enqueueSnackbar((response?.message || error), {variant: 'error'});
  //     }
  //   });
  // }

  // const onModalClose = useCallback(
  //   () => {
  //     setOpenModal(false);
  //   },
  //   [setOpenModal],
  // )

 
  // const onSuccess = useCallback(
  //   () => {
  //     // getApprovalList();
  //     setOpenModal(false);
  //     setLibraryInfo({id: null});
  //   },
  //   [setOpenModal],
  // )

  // const editLibraryDetails = (libraryId) => {
  //   setLibraryInfo({ id: libraryId });
  //   setOpenModal(true);
  // }

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if((fromDate && toDate)) {
      getBookingsDataByDate({fromDate: getDbFormat(fromDate), toDate: getDbFormat(toDate)});
    }else{
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }

  const onStatusChange = (event) => {
    setBookingStatus( event.target.value);
  }

  const reactDataGridExportCSV = (gridRef, fileName) => {
    const SEPARATOR = ',';
    // const columns = gridRef.current.visibleColumns;
  
    const header = ['Booking No', 'Booking Date', 'Time', 'Total Seats', 'Seats Nos', 'Payment Mode', 'Transaction Id', 'Library', 'Customer Name', 'Customer Mobile No', 'Amount', 'Status', 'Creation Date' ].join(SEPARATOR);
    const rows = gridRef.current.data.map((data) => {
      const rowValue = [];
      rowValue.push(data?.bookingId || '');
      rowValue.push(data?.fromDate || '');
      rowValue.push(tConvert(data?.fromTime) || '');
      rowValue.push(data?.seatCount || 0);
      rowValue.push(`"${(data?.seatIds || []).join(', ')}"` || '');
      rowValue.push(data?.bookingTransaction?.paymentChannel || '');
      rowValue.push(data?.bookingTransaction?.transactionId || '');
      rowValue.push(data?.library?.name || '');
      rowValue.push(data?.user?.firstName || '');
      rowValue.push(data?.user?.mobile || '');
      rowValue.push(data?.bookingTransaction?.amount || '');
      rowValue.push(getBookingStatus(data) || '');
      rowValue.push(data?.createdOn || '');
      return rowValue.join(SEPARATOR);
    });
    const contents = [header].concat(rows).join('\n');
    const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });
    downloadBlob(blob, fileName);
  };

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        All Bookings
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            <Paper elevation={0} sx={{p:1, bgcolor: "#f3f3f3"}}>
              <Typography variant="subtitle2" gutterBottom component="div">
                Filters
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} >
                <Box sx={{mt: 2}}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDateRangePicker
                      inputFormat="dd/MM/yyyy"
                      startText="From Date"
                      endText="To Date"
                      value={filterDates}
                      // clearable={true}
                      onChange={(newValue) => {
                        setFilterDates(newValue);
                      }}
                      onAccept={(data) => onDateAccepted(data)}
                      renderInput={(startProps, endProps) => (
                        <React.Fragment>
                          <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                          <Box sx={{ mx: 1 }}> to </Box>
                          <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                        </React.Fragment>
                      )}
                      />
                  </LocalizationProvider>
                </Box>
                <Box sx={{pt: 2, width: 180, pl:1}}>
                  <FormControl fullWidth>
                    <InputLabel id="status-select-label">Status</InputLabel>
                    <Select
                      labelId="status-select-label"
                      id="demo-simple-select"
                      value={bookingStatus}
                      label="Status"
                      size="small"
                      onChange={onStatusChange}
                    >
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value='Ongoing'>Ongoing</MenuItem>
                      <MenuItem value='Upcoming'>Upcoming</MenuItem>
                      <MenuItem value='Completed'>Completed</MenuItem>
                      <MenuItem value='Cancelled'>Cancelled</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} textAlign="right" >
            <Button onClick={() => reactDataGridExportCSV(gridRef, 'bookings.csv') } startIcon={<DownloadIcon />} variant="outlined" color="success" sx={{textTransform: 'none'}}>Export CSV</Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Box component="div" sx={{ maxHeight: 720, width: '100%' }}>
                <ReactDataGrid
                  handle={setGridRef}
                  // idProperty="index"
                  style={gridStyle}
                  defaultFilterValue={defaultFilterValue}
                  columns={columns}
                  dataSource={allBookings.filter((ele) => (bookingStatus === 'All' ? true : bookingStatus === getBookingStatus(ele)) )}
                  rowHeight={null} 
                  minRowHeight={50}
                />
            </Box>
          </Grid>
        </Grid>
      </Box> 
      {/* <FullScreenModal open={openModal} onModalClose={onModalClose} title={'View/Edit Library'}>
        <EditProperty libraryId={libraryInfo.id} onSuccess={onSuccess} onFailure={onModalClose} />
      </FullScreenModal> */}
    </Paper>
  );
}
 
export default React.memo(BookingsPage);
